import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://vdovjwlprywruiqkaotz.supabase.co'; // <- Înlocuiește cu URL-ul tău
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZkb3Zqd2xwcnl3cnVpcWthb3R6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDY4MDUwOTAsImV4cCI6MjA2MjM4MTA5MH0.WruzTOVnWV0IB7OHrOvVx3lM3n4UazQK92WphvVr8vk';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
